export default __webpack_public_path__ + "static/media/No.1-5.a945fb73.jpg";